export default [
	{
		path: '/',
		name: '',
		component: () => import('./views/inscricao/index.vue')
	},
	{
		path: '/cadastro',
		component: () => import('./views/usuario/cadastro.vue'),
		meta: {
			anonymous: true
		}
	},
	{
		path: '/login',
		component: () => import('./views/usuario/login.vue'),
		meta: {
			anonymous: true
		}
	},
	{
		path: '/recuperarsenha',
		component: () => import('./views/usuario/recuperarSenha.vue'),
		meta: {
			anonymous: true
		}
	},
	{
		path: '/redefinirsenha',
		component: () => import('./views/usuario/redefinirSenha.vue'),
		meta: {
			anonymous: true
		}
	},
	{
		path: '/inscricao/familia/responsavel/:id?',
		component: () => import('./views/inscricao/familia/responsavel.vue')
	},
	{
		path: '/inscricao/familia/familiares',
		component: () => import('./views/inscricao/familia/familiares.vue')
	},
	{
		path: '/inscricao/residencia',
		component: () => import('./views/inscricao/residencia/residencia.vue')
	},
	{
		path: '/inscricao/residencia/comodos',
		component: () => import('./views/inscricao/residencia/comodos.vue')
	},
	{
		path: '/inscricao/residencia/familias',
		component: () => import('./views/inscricao/residencia/familias.vue')
	},
	{
		path: '/inscricao/arquivos',
		component: () => import('./views/inscricao/arquivos/arquivos.vue')
	},
	{
		path: '*',
		component: () => import('./views/404.vue')
	}
];